import React, { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { Textarea } from "src/@/components/ui/textarea";

const HttpRequestComponent = ({block, changeBlock}) => {
  const [headers, setHeaders] = useState([{ key: "", value: "" }]);
  const [body, setBody] = useState("");

  console.log(block)

  const handleHeaderChange = (index, key, value) => {
    const newHeaders = [...headers];
    newHeaders[index] = { key, value };
    setHeaders(newHeaders);
    let event = {
      name: "httpHeaders",
      value: newHeaders
    }
    changeBlock(event)
  };

  const addHeader = () => {
    setHeaders([...headers, { key: "", value: "" }]);
  };

  useEffect(() => {
 
  }
  , [headers, block])


  return (
    <Card className="w-full">
    <CardHeader>
    <h3 className="text-lg font-semibold">{block?.name}</h3>
    </CardHeader>
    <CardContent>

    <div className="p-2 rounded-lg">
      {/* Webhook URL */}
      <label className="block mb-2">Url:</label>

      <Input
        type="text"
        value={block?.httpUrl}
        onChange={(e) => {
          let event = {
            name: "httpUrl",
            value: e.target.value
          }
          changeBlock(event)
        }}
        placeholder="Url"
        className="w-full p-2 mb-4  rounded-md"
      />

      {/* Method */}
      <div className="mb-4">
        <label className="block mb-2">Método:</label>
        <Select 
        value={block?.httpMethod}
        onValueChange={e => {
          let event = {
            name: "httpMethod",
            value: e
          }
          changeBlock(event)
          console.log(event)
        }}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder={"Selecione"} />
              </SelectTrigger>
              <SelectContent>
                {["POST","GET", "PUT", "DELETE"].map((item) => (
                  <SelectItem key={item} value={item}>
                    {item}
                  </SelectItem>
                ))}

                {/* Add more options if needed */}
              </SelectContent>
            </Select>

      </div>

      {/* Headers */}
      <div className="mb-4">
        <label className="block mb-2">Cabeçalhos:</label>
        {/* {headers.map((header, index) => (
          <div key={index} className="mb-2 flex space-x-2">
            <Input
              type="text"
              placeholder="Chave"
              value={header.key}
              onChange={(e) => handleHeaderChange(index, e.target.value, header.value)}
              className="p-2  rounded-md w-1/2"
            />
            <Input
              type="text"
              placeholder="Valor"
              value={header.value}
              onChange={(e) => handleHeaderChange(index, header.key, e.target.value)}
              className="p-2  rounded-md w-1/2"
            />
          </div>
        ))} */}
        <Button
          onClick={addHeader}
          className="bg-slate-500 px-4 rounded-md h-[30px]"
        >
          + Adicione um Valor
        </Button>
      </div>
      <div className="mb-4">
          <label className="block  mb-2">Body:</label>
          <Textarea
            value={block?.httpBody}
            onChange={(e) => {
              let event = {
                name: "httpBody",
                value: e.target.value
              }
              changeBlock(event)
            }}
            className="w-full p-2  rounded-md"
            rows={4}
          />
        </div>


    </div>
    </CardContent>
    </Card>
  );
};

export default HttpRequestComponent;
